import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { uccUsers } from './vehicleHistory.model';
import { Observable } from 'rxjs'

@Injectable()
export class vehicleHistoryService {
    public pushID: any;
    vehMaintDocCol: AngularFirestoreCollection<uccUsers>;
    vehMaintDoc: AngularFirestoreDocument<uccUsers>;
    vehStatusCol: AngularFirestoreCollection<uccUsers>;
    vehStatusDoc: AngularFirestoreDocument<uccUsers>;

 
   vehMainListCol : AngularFirestoreCollection<any[]>;
   vehMainListDoc : AngularFirestoreDocument<any[]>;



    vehiclesMaint: Observable<uccUsers[]>
    maintItems: Observable<uccUsers[]>;
    maintItemsStatus: Observable<uccUsers[]>;

    constructor(public afs: AngularFirestore) {
        this.vehMaintDocCol = this.afs.collection('Maintenance');
        this.vehStatusCol = this.afs.collection('VeicleStatus');

  

        // this.vehiclesMaint = this.vehMaintDocCol.snapshotChanges().map(changes => {
        //     return changes.map(a => {
        //         const data = a.payload.doc.data() as MaintVehicle;
        //         data.id = a.payload.doc.id;
        //         return data;
        //     })UccUsersService
        // });data
        this.maintItems = this.afs.collection('Maintenance').valueChanges();
    }



    insertVehicleDoc(data) {
        var doc_id = this.afs.createId();

        var test = this.afs.collection('vehicle_maintenace_list').doc('insertVehData').collection('insertVehData').add(data);
      }

    updateVehicleDoc(data){

        var doc_id = this.afs.createId();


        var test2 = this.afs.collection('vehicle_maintenace_list').doc('updateVehData').collection('updateVehData').add(data);

    }

    assignmentDoc(data){
        var doc_id = this.afs.createId();

        var test3 = this.afs.collection('vehicle_maintenace_list').doc('assignmentVehData').collection('assignmentVehData').add(data);
    }










    // addVehStatusDoc(status, date) {
    //     status.push_id = this.afs.createId();
    //     this.vehStatusDoc = this.afs.collection('VeicleStatus').doc(status.vehId).collection(date).doc(status.push_id);
    //     this.vehStatusDoc.set(status)
    //     // console.log(status.push_id)
    //     // console.log(status)
    // }

    // getDocStatus(obj) {
    //     this.maintItems = this.afs.collection('Maintenance', ref => ref
    //         // .where('statusDate', '==', obj.statusDate)
    //         .where('Status', '==', obj.Status)
    //         .where('stage', '==', obj.stage)
    //         .where('tab_position', '==', obj.tab_position)
    //         .where('request_status', '==', obj.request_status)
    //         .where('prjid', '==', obj.prjid).where('vehId', '==', obj.vehId)
    //     ).valueChanges();
    //     // console.log("para", obj)
    //     return this.maintItems
    // };


    
}


// WEBPACK FOOTER //
// ./src/app/admin/vehicles/vehicleMngt/vehicleHistory.service.ts